<style scoped lang="scss">
    .hardship-reason {
        font-size: 1.2em;
        margin-bottom: 8px;

        display: flex;

        .reason-text {

        }
    }
    .member-hardship-container {
        .member-title {
            font-size: 1.4em !important;
            margin-bottom: 10px;
            font-weight: bold;
        }

        .member-section {
            margin-left: 0px;
        }
    }
    .label-large {
        font-size: 1.3em;
        margin-bottom: 25px;

        display: flex;
        input[type=checkbox] {
            transform: scale(1.3);
            margin-right: 6px;
        }
    }

    .checkbox-container {
        margin-right: 6px;
        height: 100%;
    }

    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
    }
</style>

<template>
    <div class="uk-form" v-if="application">


        <div class="uk-grid uk-margin-top uk-margin-large-bottom">

            <div class="uk-width-1-1 uk-margin-bottom">
                <p style="color: red;">{{ selection_pass_error }}</p>
                <h2 class="uk-align-center">
                    {{ __('tenant.cov_title', { program: program['program_abbreviation'] }) }}
                </h2>
                <i><strong>
                    {{ __(`tenant.cov_subtitle`) }}
                </strong></i>
            </div>

            <div class="uk-width-1-1 member-hardship-container" v-for="(member, i) in hhMembers" v-if="i === 0">
                <div class="member-title">{{ __('tenant.cov_self_cert') }}</div>

                <!-- Unemployed -->
                <label class="label-large">
                    <div class="checkbox-container">
                        <input type="checkbox" v-model="member.is_unemployed" id="is_unemployed">
                    </div>
                    <div>
                        {{ __('tenant.cov_sec_i_title') }}
                    </div>
                </label>
                <div class="uk-grid uk-margin-bottom uk-margin-top member-section" v-if="member.is_unemployed">
                    <div class="uk-width-1-1">
                        <p></p>
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom">
                        <date-picker
                                :name="__('tenant.cov_date_unemp')"
                                :label="__('tenant.cov_date_unemp')"
                                v-model="member.date_unemployed"
                                :config="datePickerConfig"
                                placeholder="Required"
                                rules="required"
                        />
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom" v-if="member.date_unemployed">
                        <date-picker
                                :name="__('tenant.cov_date_unemp_applied')"
                                :label="__('tenant.cov_date_unemp_applied')"
                                v-model="member.date_apply_unemployed"
                                :config="datePickerConfig"
                                placeholder="If Applicable"
                        />
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom" v-if="member.date_unemployed && member.date_apply_unemployed">
                        <date-picker
                                :name="__('tenant.cov_date_unemp_awarded')"
                                :label="__('tenant.cov_date_unemp_awarded')"
                                v-model="member.date_award_unemployed"
                                :config="datePickerConfig"
                                placeholder="If Applicable"
                        />
                    </div>
                    <div class="uk-width-small-1-1 uk-width-large-1-4 uk-margin-bottom" v-if="member.date_unemployed && member.date_apply_unemployed && member.date_award_unemployed">
                        <date-picker
                                :name="__('tenant.cov_date_reemployed')"
                                :label="__('tenant.cov_date_reemployed')"
                                v-model="member.date_reemployed"
                                :config="datePickerConfig"
                                placeholder="If Applicable"
                        />
                    </div>
                </div>
                <div class="uk-margin-bottom"></div>
                <!-- / Unemployed -->

                <!-- Covid Hardship -->
                <label class="label-large">
                    <div class="checkbox-container">
                        <input type="checkbox" v-model="member.experienced_covid_hardship" id="experienced_covid_hardship">
                    </div>
                    <div>
                        {{ __('tenant.cov_sec_ii_title') }}
                    </div>
                </label>
                <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section" v-if="member.experienced_covid_hardship">
                    <div class="uk-width-1-1">
                        <div class="uk-grid">
                            <div class="uk-width-1-1 hardship-reason" v-for="(reason, reasonKey) in reasons">
                                <label class="checkbox-container">
                                    <input type="checkbox" v-model="member.hardship_reasons" :value="reason.id">
                                    {{ reason.body }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="uk-width-1-1 uk-margin-top">
                        <validated-section :errors="errors" field="hardship_explanation">
                            <label>{{ __('tenant.for_applicants_certifying') }}</label>
                            <textarea placeholder="Explain Your Hardship..." v-model="member.hardship_reason_explanation" class="uk-form-large uk-input uk-width-1-1"></textarea>
                        </validated-section>
                    </div>

                    <!--<div class="uk-width-1-1 uk-margin-top">-->
                        <!--<validated-section :errors="errors" field="hardship_upload">-->
                            <!--<label class="font-weight: bold">UPLOAD PROOF OF HARDSHIP:</label>-->
                            <!--<p>Note: You are required to upload proof of hardship if you do not give an explanation above.</p>-->
                            <!--<p class="uk-text-danger">WARNING: Do NOT Upload Any Medical Documents</p>-->
                            <!--<validated-section :errors="errors" field="document">-->
                                <!--<div>-->
                                    <!--<dropzone-uploader-->
                                            <!--:dropzone-options="dropzoneOptions"-->
                                            <!--:form-data="formDataForMember(member)"-->
                                            <!--@max-files-succeeded="onMaxFilesExceeded"-->
                                            <!--@onDeleted="documentDeleted"-->
                                    <!--&gt;-->
                                        <!--<div class="dropzone-custom-content file-dropzone">-->
                                            <!--<h3 class="dropzone-custom-title">Drop File Here or Click to Select a File.</h3>-->
                                        <!--</div>-->
                                    <!--</dropzone-uploader>-->
                                <!--</div>-->
                            <!--</validated-section>-->

                        <!--</validated-section>-->
                    <!--</div>-->
                </div>
                <div class="uk-margin-bottom"></div>
                <!-- / Covid Hardship -->

                <!-- Housing Instability -->
                <div class="member-title">{{ __('tenant.cov_sec_iii_section_title') }}</div>
                <p>
                    {{ __(`tenant.cov_sec_iii_section_subtitle`, {program_abbreviation: program['program_abbreviation']}) }}
                </p>
                <label class="label-large">
                    <div class="checkbox-container">
                        <input type="checkbox" v-model="member.experienced_housing_instability" id="experienced_housing_instability">
                    </div>
                    <div>
                       {{ __(`tenant.cov_sec_iii_title`, { program_abbreviation: program['program_abbreviation'] }) }}
                    </div>
                </label>
                <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section" v-if="member.experienced_housing_instability">
                    <div class="uk-width-1-1 uk-margin-bottom">
                        <p>{{ __('tenant.cov_hardship_includes') }}</p>
                    </div>
                    <div class="uk-width-1-1">

                        <div class="uk-width-1-1">
                            <div class="uk-grid">
                                <div class="uk-width-1-1 hardship-reason" v-for="(reason, reasonKey) in housingReasons" :key="reasonKey">
                                    <label class="checkbox-container">
                                        <input type="checkbox" v-model="member.housing_hardship_reasons" :value="reason.id">
                                        {{ reason.body }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="uk-width-1-1 uk-margin-top">
                            <validated-section :errors="errors" field="hardship_explanation">
                                <label class="font-weight: bold">{{ __('tenant.housing_instabilioty_homelessness') }}</label>
                                <p>{{ __('tenant.other_plz_explain') }} </p>
                                <textarea placeholder="Other - Please explain..." v-model="member.housing_hardship_reason_explanation" class="uk-form-large uk-input uk-width-1-1" id="housing_hardship_reason_explanation"></textarea>
                            </validated-section>
                        </div>

                        <div class="uk-width-1-1 uk-margin-top" v-if="programSettings['uses-upload-for-housing-hardship']">
                            <validated-section :errors="errors" field="hardship_upload">
                                <label class="font-weight: bold">{{ __('tenant.cov_upload_proof') }}</label> <span class="uk-text-danger">{{ __('tenant.cov_med_doc_warning') }}</span>
                                <validated-section :errors="errors" field="document">
                                    <div>
                                        <dropzone-uploader
                                                :dropzone-options="dropzoneOptions"
                                                :form-data="formDataForMember(member)"
                                                @max-files-succeeded="onMaxFilesExceeded"
                                                @onDeleted="documentDeleted">
                                            <div class="dropzone-custom-content file-dropzone">
                                                <h3 class="dropzone-custom-title">{{ __('tenant.inc_drop_file') }}</h3>
                                            </div>
                                        </dropzone-uploader>
                                    </div>
                                </validated-section>

                            </validated-section>
                        </div>
                    </div>
                </div>
                <div class="uk-margin-bottom" v-else></div>
                <!-- / Housing Instability -->


            </div> <!-- End Member Loop -->
        </div>


        <div class="uk-grid" v-if="applicant">
            <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2">
                <p class="uk-">
                    {{ __('tenant.cov_under_penalty', {program: application.program.program_abbreviation }) }}
                </p>
                <validated-section :field="'signature_'+applicant.id" :errors="errors">
                    <signature-box @updated="onSignatureUpdated"
                                   :user-key="applicant.id"
                                   :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
                                   :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                                   :name="applicant.first_name + ' ' + applicant.last_name"
                                   :color="programSettings['primary-program-color']"
                    ></signature-box>
                </validated-section>
            </div>
        </div>

        <p style="color: red;" id="footer-error"></p>
    </div>
</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import VueDropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import DropzoneUploader from "../../../../../components/AppWizard/Documents/DropzoneUploader";

    export default {
        name: "CovidHardshipReasons",
        components: {DropzoneUploader, SignatureBox, ValidatedSection, VueDropzone},
        data() {
            return {
                errors: {},
                selection_pass_error: '',
                dropzoneOptions: {
                    url: '/api/hope/documents',
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    maxFiles: 1,
                    acceptedFiles: ['.pdf', '.png', '.jpg', '.jpeg'].join(','),
                },
                hardshipReasons: [],
                housingHardshipReasons: [],
                hardshipReasonsExplanations: '',
                housingHardshipReasonsExplanations: '',
                signatureData: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                applicant: state => state.applicant,
                hhMembers: state => state.application.household.members,
                reasons: state => state.assets.hardshipReasons,
                housingReasons: state => state.assets.housingReasons,
                signatures: state => state.applicant.signatures,
            }),
            ...mapState('App', {
                env: state => state.env,
            }),
            ...mapGetters('Application', [ 'program',  'programSettings' ]),
        },
        watch: {
            application(newValue) {
                if(newValue) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) {
                this.initData();
            }
        },
        methods: {
            initData() {
                const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `app-hardship`)
                if(signatureFiltered) {
                    this.$set(this.signatureData, this.applicant.id, { signed_at: signatureFiltered.created_at, completed: true });
                }
            },

            addFinding(member) {
                member.finding_types.push({
                    pivot: {
                        finding_type_id: null,
                        finding_type_level: null,
                        household_application_id: this.application.id,
                        household_member_id: member.id,
                        household_id: member.household_id,
                        notes: '',
                    }
                })
            },

            formDataForMember(member) {
                return {
                    household_application_id: this.application.id,
                    household_member_id: member.id,
                    applicant_user_id: this.application.applicant_user_id,
                    file_type: 'proof_of_hardship',
                }
            },
            onMaxFilesExceeded(file) {
                console.log('max files exceeded', file);
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },
            async validateStep() {
                this.errors = {};
                let is_unemployed = document.getElementById('is_unemployed').checked;
                let experienced_covid_hardship = document.getElementById('experienced_covid_hardship').checked;
                let experienced_housing_instability = document.getElementById('experienced_housing_instability').checked;
                let page_error = document.getElementById('footer-error');
                let selection_pass_error = 'You must certify at least one option from (I) and (II), and option (III).';

                this.selection_pass_error = '';
                page_error.innerHTML = '';
                if(!is_unemployed && !experienced_covid_hardship) {
                    this.selection_pass_error = selection_pass_error;
                    return false; //invalid
                }

                if(!experienced_housing_instability) {
                    this.selection_pass_error = selection_pass_error;
                    return false; //invalid
                }

                if(!this.signatureData[this.applicant.id]) {
                    this.errors['signature_'+this.applicant.id] = {
                        errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
                    };
                }else if(this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
                    this.errors['signature_'+this.applicant.id] = {
                        errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
                    };
                }

                //validate the user has selected at least one sub option if they selected II or III
                selection_pass_error =  '';
                await _.each(this.application.household.members, function(member, i) {
                    if(i === 0) {
                        //validate have selected at least 1 option from section #2
                        // console.log(member.hardship_reasons.length);
                        // console.log(experienced_covid_hardship);
                        if(member.hardship_reasons.length === 0 && experienced_covid_hardship) {
                            selection_pass_error += '<ul><li>Please check at least one reason box from Section II. If you selected other, please enter a reason in the other text area.</li></ul>';
                        }

                        //validate have selected at least 1 option from section #3
                        // console.log(member.housing_hardship_reasons.length);
                        // console.log(experienced_housing_instability);
                        if(member.housing_hardship_reasons.length === 0 && experienced_housing_instability) {
                            selection_pass_error += '<ul><li>Please check at least one reason box from Section III. If you selected other, please enter a reason in the other text area.</li></ul>';
                        }
                    }

                    page_error.innerHTML = selection_pass_error;
                });

                if(selection_pass_error !== '') {
                    return false;
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }

            },
            async save() {

                let _members = _.map(this.application.household.members, member => _.pick(member, [
                    'id',
                    'is_unemployed',
                    'date_unemployed',
                    'date_apply_unemployed',
                    'date_award_unemployed',
                    'date_reemployed',
                    'experienced_covid_hardship',
                    'hardship_reasons',
                    'hardship_reason_explanation',
                    'experienced_housing_instability',
                    'housing_hardship_reasons',
                    'housing_hardship_reason_explanation',
                    'finding_types',
                ]))

                let data = {
                    signatures: this.signatureData,
                    members: _members,
                }
                return await axios.put(`/api/hope/applications/${this.application.id}/step-hardship-reason`, data)
            },
        }
    }
</script>
